import React from 'react';
import {
  Form,
  FieldBoolean,
  FieldSelect,
  FieldTextInput,
  PrimaryButton,
  SecondaryButton
} from '../../../components';
import * as validators from '../../../util/validators';
import { Form as FinalForm } from 'react-final-form';
import {CgCloseO } from 'react-icons/cg';

import css  from './VineyardReviews.module.css'

const AddReviewForm = (props) => {
  return (
    <FinalForm
      {...props}
      initialValues={props.initialValues}
      render={fieldRenderProps => {
        const {
          // rootClassName,
          // className,
          formId,
          handleSubmit,
          inProgress,
          setTosModelOpen,
          handleOnChangeImage,
          uploadPhotoLoading,
          photo,
          handleRemoveImage,
          // invalid,
          // intl,
          // setShowWineryForm,
          // values
          // onOpenTermsOfService,
        } = fieldRenderProps;

        const submitInProgress = inProgress;
        // const submitDisabled = invalid || submitInProgress;
        const submitDisabled = submitInProgress;

        return (
          <Form
            className={css.formRoot}
            onSubmit={handleSubmit}
          >
            <div className={css.inputsWrapper}>
              <FieldSelect
                rootClassName={css.rootInput}
                id="quality"
                name="quality"
                label="Wine Quality"
                validate={validators.required('Wine Quality is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index) => (
                  <option key={index} value={v}>{v}</option>
                ))}
              </FieldSelect>
              <FieldSelect
                rootClassName={css.rootInput}
                id="variety"
                name="variety"
                label="Wine Variety"
                validate={validators.required('Wine Variety is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index)=> (
                  <option key={index} value={v}>{v}</option>
                ))}
              </FieldSelect>
              <FieldSelect
                rootClassName={css.rootInput}
                id="venueAmbiance"
                name="venueAmbiance"
                label="Venue Ambiance"
                validate={validators.required('Venue Ambiance is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index) => (
                  <option key={index} value={v}>{v}</option>
                ))}
              </FieldSelect>
              <FieldSelect
                rootClassName={css.rootInput}
                id="affordable"
                name="affordable"
                label="Affordable"
                validate={validators.required('affordable is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index) => (
                  <option key={index}value={v}>{v}</option>
                ))}
              </FieldSelect>
              <FieldSelect
                rootClassName={css.rootInput}
                id="foodOfferings"
                name="foodOfferings"
                label="Food Offerings"
                validate={validators.required('Food Offerings is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index) => (
                  <option key={index} value={v}>{v}</option>
                ))}
              </FieldSelect>
              <FieldSelect
                rootClassName={css.rootInput}
                id="customerService"
                name="customerService"
                label="Customer Service"
                validate={validators.required('Customer Service is required')}
              >
                <option value="">Score from 1 to 5</option>
                {[1, 2, 3, 4, 5].map((v, index) => (
                  <option key={index}value={v}>{v}</option>
                ))}
              </FieldSelect>
            </div>
            <div className={css.fullWidth}>
              <FieldTextInput
                type="textarea"
                id={formId ? `${formId}.description` : 'description'}
                name="description"
                autoComplete="description"
                label="Description"
                placeholder="description..."
                validate={validators.required('Description is required')}
              />
            </div>
            <div className={css.btnsWrapper}>
              <PrimaryButton
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
              >
                Add Review
              </PrimaryButton>
              <SecondaryButton
                style={{marginLeft: "10px"}}
                type="button"
                onClick={() => {
                  setTosModelOpen(false);
                }}
                disabled={submitDisabled}
              >
                Cancel
              </SecondaryButton>
            </div>
          </Form>
        );
      }}
    />
  )
}

export default AddReviewForm;
